import { Label, Tag } from 'konva/lib/shapes/Label';
import { Line } from 'konva/lib/shapes/Line';
import { Text } from 'konva/lib/shapes/Text';

export class CustomSegmentMarker {
    private _options: any;
    private _group: any;
    private _label: any;
    private _tag: any;
    private _text: any;
    private _line: any;
    private _originalGroup : any ;
   
    constructor(options : any) {
        
        this._options = options ;

        document.addEventListener('customRemove', (event) => { 
            
            const firedSegmentId = (event as any).detail.segmentId
            const thisClassSegmentId = this._options.segment._id
            if(firedSegmentId === thisClassSegmentId )  {

                if(this._group.children.length >= 3) {
                    this._group.children.pop()
                }
            }
        } )

        document.addEventListener('custom', (event) => {
            const isPrevTooClose = (event as any).detail.isPrevTooClose
            const isNextTooClose = (event as any).detail.isNextTooClose

            const firedSegmentId = (event as any).detail.segmentId
            const thisClassSegmentId = this._options.segment._id
            const segment = this._options ; 
            if(firedSegmentId === thisClassSegmentId )  {
                this.activateTimeMarker({isPrevTooClose, isNextTooClose});
            }
        });            
    }
    
    init(group: any) { 
        this._originalGroup = JSON.parse(JSON.stringify(group))  
        const color = this._options.segment.color;        
        this._label = this.makeSidebar()                
        this._label.add(this.makeSideSquare(color));          
        this._label.add(this.setInnerText(""));
        this._line = this.makeSideLine(color)        
        this._group = group;
        this._group.add(this._label);
        this._group.add(this._line);        
        this.fitToView();
    }


    activateTimeMarker({isPrevTooClose, isNextTooClose} : {isPrevTooClose : boolean, isNextTooClose : boolean}) {

            if(this._group.children.length >= 3) {
                this._group.children.pop()
            }
            this._label = this.makeTopLabel()
            this._label.add(this.makeTopLevelBackground(this._options.segment.color));
            this._label.add(this.makeTopLabelText());            
            this._group.add(this._label);         
            this.fitToView();
    }    


    bindEventHandlers() {
        this._group.on('mouseenter', function(e : MouseEvent) {
            document.body.style.cursor = 'move';
        });
    
        this._group.on('mouseleave', function() {
            document.body.style.cursor = 'default';
        });
    }

    fitToView() {
        const height = this._options.layer.getHeight();
        const labelHeight = this._text.height() + 2 * this._text.padding();
        const offsetTop = 14;
        const offsetBottom = 26;
        this._group.y(offsetTop + labelHeight + 0.5);
        this._line.points([0.5, 0, 0.5, height - labelHeight - offsetTop - offsetBottom]);
    }

    transformSideColor(color : string) {
        return new Line({
            x:           0,
            y:           0,
            stroke:      color,
            strokeWidth: 1
        })
    }
    makeTopLevelBackground(color : string){
        return new Tag({
            fill:             color,
            stroke:           "#FFFFFF",
            strokeWidth:      1,
            pointerWidth:     10,
            pointerHeight:    10,
            lineJoin:         'round',
        });
    }

    makeTopLabelText(){
        return new Text({
            text:     this._options.startMarker === true 
                    ? secondToHHMMSS(this._options.segment.startTime)
                    : secondToHHMMSS(this._options.segment.endTime),
            fontFamily: 'Calibri',
            fontSize:   14,
            padding:    5,
            fill:       'white'
        });
    }

    makeTopLabel(){
        return new Label({
            x: -30.5,
            y: -32.5
        })
    }

    makeSidebar(){
        const label = new Label({
            x: -5,
            y: 16.5
        });

        return label
    }   

    makeSideSquare(color : string){
        const tag =  new Tag({
            offsetY : -50,
            scaleY: 0.8,
            fill: color,
            visible: true,
            stroke: "#123456",
            strokeWidth: 1,
        });

        const options = this._options
        
        tag.on('mouseover', function (e) {                     
            globalThis.latestSegmentDuration = parseFloat((options.segment.endTime - options.segment.startTime).toFixed(3))
            globalThis.latestStartTime = parseFloat (options.segment.startTime.toFixed(3))
            globalThis.latestEndTime = parseFloat (options.segment.endTime.toFixed(3))             
        })
        
      return tag
    }

    makeSideLine(color : string){
        return new Line({
            x: 0,
            y: 0,
            stroke: color,
            strokeWidth: 1
        });
    }

    setInnerText(newtext : string){
        const txt = new Text({
            text : newtext,
            fontFamily: 'Calibri',
            fontSize: 14,
            padding: 5,
            fill: 'white'
        });

        this._text = txt
        return txt
    }    

    removeTag(){
        this._label.remove(this._tag);
    }    
}

function secondToHHMMSS(seconds : number) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = (seconds % 3600) % 60;
    const onlySeconds = Math.floor(remainingSeconds)
    const point = String( remainingSeconds - onlySeconds).split(".").at(-1)!.substring(0,3)
    const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${onlySeconds.toString().padStart(2, "0")},${point.padStart(3, "0")}`;
    return timeString
}